// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toggleContainer":"_1i2Heq","toggleButton":"_38yETb","richtextContainer":"_3qc9a7","icon":"keO4qe"};